import React from 'react';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import style from './print-modal.module.less';

export const PrintModalLoading = () => (
  <Modal className={style['print-modal']}>
    <ModalBody className={style['print-modal-body']}>
      <LoadingIndicator />
    </ModalBody>
  </Modal>
);
